import React, { useState } from 'react'

const Inquiryone = () => {
    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        phone: '',
        country: '',
        subject: '',
        message: ''
    });
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(false);

    // Form handling
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};
        
        if (!formData.fullName.trim()) {
            newErrors.fullName = 'Full Name is required';
        }
        
        if (!formData.email.trim()) {
            newErrors.email = 'Email Address is required';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = 'Please enter a valid email address';
        }
        
        if (!formData.country.trim()) {
            newErrors.country = 'Country is required';
        }
        
        if (!formData.subject.trim()) {
            newErrors.subject = 'Subject is required';
        }
        
        if (!formData.message.trim()) {
            newErrors.message = 'Message is required';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!validateForm()) {
            return;
        }

        setIsSubmitting(true);

        try {
            // Send to your PHP backend
            const response = await fetch('https://thenriadvisors.com/api/send-email.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    fullName: formData.fullName,
                    email: formData.email,
                    phone: formData.phone || 'Not provided',
                    country: formData.country,
                    helpDescription: `Subject: ${formData.subject}\n\nMessage: ${formData.message}`,
                    contactMethod: 'Email',
                    bestTime: 'Anytime'
                })
            });

            const result = await response.json();

            if (result.success) {
                setSubmitSuccess(true);
                setFormData({
                    fullName: '',
                    email: '',
                    phone: '',
                    country: '',
                    subject: '',
                    message: ''
                });
                setErrors({});

                // Reset success message after 5 seconds
                setTimeout(() => {
                    setSubmitSuccess(false);
                }, 5000);
            } else {
                setErrors({ submit: result.message || 'Failed to send message. Please try again.' });
            }

        } catch (error) {
            console.error('Error sending email:', error);
            setErrors({ submit: 'Failed to send message. Please try again.' });
        } finally {
            setIsSubmitting(false);
        }
    };
    return (
        <section style={{ padding: "60px 0" , marginBottom: "20px", paddingBottom: "100px"}}>
  <div className="container" id='about-will'>
    <div className="row align-items-center">
      {/* LEFT: Offer Text */}
      <div className="col-lg-6 col-md-12 mb-4 mb-lg-0">
        <div>
          <h2 style={{ fontWeight: 700, fontSize: "2.4rem", color: "#162032", marginBottom: 0 }}>
            Trust us to take the hassle out of property management
          </h2>
          <p style={{ fontSize: 18, color: "#444", marginTop: 18, marginBottom: 18 }}>
            With The NRI Advisors, your property is professionally managed - from start to finish.
          </p>

          <h4 style={{ fontWeight: 700, marginBottom: 0 }}>Let’s Get Started</h4>
          <div style={{ fontWeight: 700, fontSize: 20, margin: "8px 0 0 0" }}>
            [Book Your Free Consultation]
          </div>
          <div style={{ color: "#444", margin: "8px 0 0 0" }}>
            <b>The NRI Advisors – Your Trusted Global Experts.</b><br></br>
            Professional solutions. Personal care. Wherever you are.

          </div>
          <div style={{ display: "flex", alignItems: "center", marginTop: 18 }}>
            <span style={{ fontSize: 32, marginRight: 12, color: "#162032" }}>
              <i className="fa-regular fa-envelope" ></i>
            </span>
            <span style={{ fontWeight: 700, fontSize: 20, color: "#222" }}>
              support@thenriadvisors.com
            </span>
          </div>
        </div>
      </div>
      {/* RIGHT: Inquiry Form */}
      <div className="col-lg-6 col-md-12">
        <div
        //   style={{
        //     background: "#fff",
        //     borderRadius: 12,
        //     boxShadow: "0 8px 40px 0 rgba(53,57,69,0.10)",
        //     padding: "40px 32px",
        //     maxWidth: 700,
        //     margin: "0 auto"
        //   }}
        >
          {/* Inquiry Form */}
          <div className="inquiry-form-one">
            {submitSuccess ? (
              <div style={{ 
                background: "#d4edda", 
                color: "#155724", 
                padding: "20px", 
                borderRadius: "8px", 
                textAlign: "center",
                marginBottom: "20px"
              }}>
                <i className="fas fa-check-circle" style={{ fontSize: "24px", marginBottom: "10px" }}></i>
                <h4>Thank you for your inquiry!</h4>
                <p>We've received your message and will get back to you within 24-48 hours.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6 mb-3 d-flex align-items-center input-icon-row">
                    <span className="input-icon">
                      <i className="fa-regular fa-user" />
                    </span>
                    <input
                      type="text"
                      name="fullName"
                      className="form-control"
                      placeholder="Full Name"
                      value={formData.fullName}
                      onChange={handleInputChange}
                      required
                      style={{ 
                        border: "none", 
                        borderBottom: errors.fullName ? "2px solid #dc3545" : "1px solid #ddd", 
                        borderRadius: 0, 
                        marginBottom: 24 
                      }}
                    />
                    {errors.fullName && <div style={{ color: "#dc3545", fontSize: "12px", marginTop: "5px" }}>{errors.fullName}</div>}
                  </div>
                  <div className="col-md-6 mb-3 d-flex align-items-center input-icon-row">
                    <span className="input-icon">
                      <i className="fa-regular fa-envelope" />
                    </span>
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="Email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      style={{ 
                        border: "none", 
                        borderBottom: errors.email ? "2px solid #dc3545" : "1px solid #ddd", 
                        borderRadius: 0, 
                        marginBottom: 24 
                      }}
                    />
                    {errors.email && <div style={{ color: "#dc3545", fontSize: "12px", marginTop: "5px" }}>{errors.email}</div>}
                  </div>
                  <div className="col-md-6 mb-3 d-flex align-items-center input-icon-row">
                    <span className="input-icon">
                      <i className="fa-solid fa-phone" />
                    </span>
                    <input
                      type="tel"
                      name="phone"
                      className="form-control"
                      placeholder="Phone Number"
                      value={formData.phone}
                      onChange={handleInputChange}
                      style={{ border: "none", borderBottom: "1px solid #ddd", borderRadius: 0, marginBottom: 24 }}
                    />
                  </div>
                  <div className="col-md-6 mb-3 d-flex align-items-center input-icon-row">
                    <span className="input-icon">
                      <i className="fa-solid flaticon-location" style={{fontWeight: "bold"}} />
                    </span>
                    <input
                      type="text"
                      name="country"
                      className="form-control"
                      placeholder="Country"
                      value={formData.country}
                      onChange={handleInputChange}
                      required
                      style={{ 
                        border: "none", 
                        borderBottom: errors.country ? "2px solid #dc3545" : "1px solid #ddd", 
                        borderRadius: 0, 
                        marginBottom: 24 
                      }}
                    />
                    {errors.country && <div style={{ color: "#dc3545", fontSize: "12px", marginTop: "5px" }}>{errors.country}</div>}
                  </div>
                  <div className="col-12 mb-3 d-flex align-items-center input-icon-row">
                    <span className="input-icon">
                      <i className="fa-solid fa-list" />
                    </span>
                    <input
                      type="text"
                      name="subject"
                      className="form-control"
                      placeholder="Subject"
                      value={formData.subject}
                      onChange={handleInputChange}
                      required
                      style={{ 
                        border: "none", 
                        borderBottom: errors.subject ? "2px solid #dc3545" : "1px solid #ddd", 
                        borderRadius: 0, 
                        marginBottom: 24, 
                        paddingBottom: 0 
                      }}
                    />
                    {errors.subject && <div style={{ color: "#dc3545", fontSize: "12px", marginTop: "5px" }}>{errors.subject}</div>}
                  </div>
                  <div className="col-12 mb-3 d-flex align-items-center input-icon-row">
                    <span className="input-icon">
                      <i className="fa-solid fa-message" />
                    </span>
                    <textarea
                      rows={3}
                      name="message"
                      className="form-control"
                      placeholder="About your requirement"
                      value={formData.message}
                      onChange={handleInputChange}
                      required
                      style={{ 
                        border: "none", 
                        borderBottom: errors.message ? "2px solid #dc3545" : "1px solid #ddd", 
                        borderRadius: 0, 
                        marginBottom: 0 
                      }}
                    />
                    {errors.message && <div style={{ color: "#dc3545", fontSize: "12px", marginTop: "5px" }}>{errors.message}</div>}
                  </div>
                </div>
                
                {errors.submit && (
                  <div style={{ 
                    color: "#dc3545", 
                    background: "#f8d7da", 
                    padding: "10px", 
                    borderRadius: "4px", 
                    marginBottom: "20px" 
                  }}>
                    {errors.submit}
                  </div>
                )}
                
                <div className="fade-in-up">
                  <button 
                    type="submit" 
                    className="btn btn-primary bg-black"
                    disabled={isSubmitting}
                    style={{ minWidth: "150px" }}
                  >
                    {isSubmitting ? (
                      <>
                        <i className="fas fa-spinner fa-spin" style={{ marginRight: "8px" }}></i>
                        Sending...
                      </>
                    ) : (
                      <>
                        Inquiry Now
                        <i className="flaticon-next" />
                      </>
                    )}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

    )
}
export default Inquiryone;